import UAParser from "ua-parser-js";

export interface ParsedUa {
  browser: string;
  browserVersion: string;
  os: string;
  osVersion: string;
  deviceType: string;
  device: string;
  engine: string;
  cpu: string;
  isBot: boolean;
  /** False when nothing in the text looks like a user-agent string (browser, OS, engine, device, bot or Mozilla/ style tokens). */
  recognised: boolean;
}

const BOT = /bot|crawler|spider|slurp|facebookexternalhit|curl\/|wget\/|python-requests|headlesschrome/i;

const BOT_NAME = /\b(Googlebot|Bingbot|bingbot|DuckDuckBot|Baiduspider|YandexBot|Slurp|facebookexternalhit|Twitterbot|LinkedInBot|AhrefsBot|SemrushBot|[A-Za-z]+bot|[A-Za-z]*crawler|[A-Za-z]*spider)\/([\d.]+)/i;
const SCRIPT_NAME = /\b(curl|Wget|python-requests|HeadlessChrome|Go-http-client|okhttp)\/([\d.]+)/i;
const KNOWN_UA = /Mozilla\/|Opera\/|Dalvik\/|AppleWebKit|Gecko\/|Trident\//i;

export function parseUserAgent(ua: string): ParsedUa {
  const r = new UAParser(ua).getResult();
  const isBot = BOT.test(ua);
  const botMatch = isBot ? ua.match(BOT_NAME) ?? ua.match(SCRIPT_NAME) : null;
  const type = r.device.type;
  const recognised = !!(r.browser.name || r.os.name || r.engine.name || type || isBot || KNOWN_UA.test(ua));
  const typeLabel = type === "mobile" ? "Mobile" : type === "tablet" ? "Tablet" : type ? type.charAt(0).toUpperCase() + type.slice(1) : isBot ? "Bot / script" : recognised ? "Desktop" : "Unknown";
  return {
    browser: r.browser.name ?? (botMatch ? botMatch[1] : "Unknown"),
    browserVersion: r.browser.version ?? (botMatch ? botMatch[2] : "Unknown"),
    os: r.os.name ?? "Unknown",
    osVersion: r.os.version ?? "",
    deviceType: typeLabel,
    device: [r.device.vendor, r.device.model].filter(Boolean).join(" "),
    engine: r.engine.name ?? "Unknown",
    cpu: r.cpu.architecture ?? "",
    isBot,
    recognised,
  };
}
